import { render, staticRenderFns } from "./ClassroomLogo.vue?vue&type=template&id=872b7d40&"
import script from "./ClassroomLogo.vue?vue&type=script&lang=js&"
export * from "./ClassroomLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports